// 開発環境用
const RadioMailAPIURL = 'https://radiomailerdev.site/'
// 本番環境用
// const RadioMailAPIURL = 'https://radiomailer.site'

export default RadioMailAPIURL